import { useEffect } from 'react';
import { FrameDataType } from '@/modules/types/frame';
import { addHashOnHex, resolveAssetUrl } from '@/lib/util';

export function useFrameStyle(
  currentFrame: FrameDataType | undefined,
  isMobile = false,
): null {
  useEffect(() => {
    if (currentFrame) {
      const frameMetaData: any = currentFrame.frameMetadata;
      const FrameStyleID = 'FrameStyle';
      const FrameStyle = document.getElementById(FrameStyleID);
      if (FrameStyle) {
        FrameStyle.remove();
      }
      const style = document.createElement('style');
      style.setAttribute('id', FrameStyleID);
      document.head.appendChild(style);
      const stylesheet = style.sheet;
      const stylePropertyPrefix = '#ModuleViewer';

      if (frameMetaData?.backgroundColor) {
        (stylesheet as CSSStyleSheet).insertRule(
          `${stylePropertyPrefix} #content-container {
            background-color: ${addHashOnHex(frameMetaData.backgroundColor)}
            }`,
          0,
        );
      }

      if (frameMetaData?.bgImage && !isMobile) {
        (stylesheet as CSSStyleSheet).insertRule(
          `${stylePropertyPrefix} #content-container {background:url("${resolveAssetUrl(
            {
              assetBasePath: currentFrame.assetBasePath,
              tenantId: currentFrame.tenantId,
              entity: 'elearnings',
              entityId: currentFrame.elearningId,
              fileType: 'images',
              fileName: frameMetaData.bgImage,
            },
          )}") repeat-y center}`,
          0,
        );
      }
    }
  }, [currentFrame, isMobile]);

  return null;
}
